export class Cls_UserLogin {
  appName: string = "";
  companyName: string = "";
  password: string = "";
  username: string = "";
  token: string = "";
}

export class Cls_GetOTPMaster {
  emailID?: string;
  companyName?: string;
  applicationName?: string;
}

export class Cls_ChangeUserPassword {
  NewPassword?: string;
  EmailID?: string;
  companyName?: string;
  applicationName?: string;
  OTP_ID?: number;
  OTP_CODE?: string;
}

export class Cls_VerifyOTPMaster {
  OTP_ID?: number;
  OTP_CODE?: string;
}
